import { motion } from "framer-motion";
import { SERVICES } from "../../constants/siteData";

export const Services = () => {
  return (
    <section
      id="services"
      className="relative bg-[#061223] py-24 md:py-32 overflow-hidden"
      data-testid="services-section"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-16">
          <p className="kicker mb-5">What we do</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tighter text-cream">
            A full range of <span className="text-coral">distribution services</span> for growing retailers.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">          {SERVICES.map((s, i) => (
            <motion.article
              key={s.num}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              className="relative p-8 md:p-10 border hairline rounded-2xl bg-white/[0.02] hover:bg-white/[0.04] hover:border-coral/40 group"
              style={{ transitionProperty: "background-color, border-color", transitionDuration: "400ms" }}
              data-testid={`service-card-${i}`}
            >
              <div className="font-display text-6xl md:text-7xl text-coral/20 group-hover:text-coral/60 leading-none mb-8"
                style={{ transitionProperty: "color", transitionDuration: "400ms" }}
              >
                {s.num}
              </div>
              <h3 className="font-display text-2xl md:text-3xl text-cream leading-tight mb-4">
                {s.title}
              </h3>
              <p className="text-white/60 leading-relaxed">{s.desc}</p>
              <div className="mt-8 flex items-center gap-2 text-sm text-coral">
                <span className="w-8 h-[1px] bg-coral" />
                Learn more
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
